export default "__VITE_ASSET__CalN59Sj__"